var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-card card",on:{"click":_vm.redirect}},[_c('h4',[_vm._v(_vm._s(_vm.heading))]),_vm._v(" "),_c('p',{class:_vm.classes},[_vm._v(_vm._s(_vm.text)+" "+_vm._s(_vm.unit.toUpperCase()))]),_vm._v(" "),_c('i',{staticClass:"material-icons"},[_vm._v(_vm._s(_vm.icon))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7623f8af","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/cards/DashboardCard.vue
// module id = gHg4
// module chunks = 0 1